export default function translateDate(date: string, dateEnd?: string | null) {
  if (dateEnd) {
    return (
      new Date(date).toLocaleString("ru-RU", { day: "2-digit", month: "2-digit", year: "numeric" }) +
      " - " +
      new Date(dateEnd).toLocaleString("ru-RU", { day: "2-digit", month: "2-digit", year: "numeric" })
    );
  }

  return new Date(date).toLocaleString("ru-RU", { month: "long", year: "numeric" });
}

export function getLocalWeek(date: Date): number {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));

  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  const weekNo = Math.ceil((((d.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
  return weekNo;
}

export function getISOYear(date: Date): number {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  d.setUTCDate(d.getDate() + 4 - (d.getDay() || 7));
  return d.getUTCFullYear();
}

export function getWeekDateRange(weekNumber: number, year: number): string {
  const firstDayOfYear = new Date(year, 0, 1);
  const firstDayOfWeek = firstDayOfYear.getDay();

  const weekStart = new Date(year, 0, 1);

  if (firstDayOfWeek <= 4) {
    weekStart.setDate(1 - (firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1));
  } else {
    weekStart.setDate(1 + (7 - firstDayOfWeek + 1));
  }

  // Добавляем (weekNumber - 1) недель
  weekStart.setDate(weekStart.getDate() + (weekNumber - 1) * 7);

  // Конец недели - через 6 дней от начала
  const weekEnd = new Date(weekStart);
  weekEnd.setDate(weekEnd.getDate() + 6);

  // Форматируем даты в DD.MM.YYYY
  const formatDate = (date: Date): string => {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    return `${day}.${month}.${date.getFullYear()}`;
  };

  return `${formatDate(weekStart)} - ${formatDate(weekEnd)}`;
}
